<script setup>
import { ref, defineEmits, onMounted } from 'vue';
import { rules } from '../common/formRules';
import { useAppStore } from '../store/app';
const store = useAppStore();

const emit = defineEmits(['onClose']);

const props = defineProps({
  customer: {
    type: Object,
    required: true,
  },
});

const newCustomer = ref({
  memberId: 0,
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  phoneNumber: '',
  address: '',
  isNew: true,
});

onMounted(() => {
  newCustomer.value = { ...props.customer };
});

const customerFormRef = ref(null);
/**
 * Submit new user
 */
const onSubmitNewCustomer = async (event) => {
  event.preventDefault();
  store.appLoading = true;
  customerFormRef.value.resetValidation();
  const validateResult = await customerFormRef.value.validate();
  // Check Validation
  if (!validateResult.valid) {
    store.appLoading = false;
    return;
  }
  let res = {};
  if (newCustomer.value.isNew) {
    res = await store.createNewUser({ newUser: newCustomer.value }); // Submit Data
  } else {
    res = await store.updateCurrentCustomer({ customer: newCustomer.value });
  }
  store.appLoading = false;
  emit('onClose', res);
};

const showDialog = ref(true);

const onClose = () => {
  emit('onClose');
};
</script>

<template>
  <v-dialog persistent v-model="showDialog" width="500">
    <v-card>
      <v-card-title>
        <h4 class="text-center">{{ newCustomer.isNew ? 'New' : 'Edit' }} Customer</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="customerFormRef">
          <v-row>
            <v-col>
              <v-text-field
                label="First Name"
                variant="outlined"
                persistent-placeholder
                v-model="newCustomer.firstName"
                :rules="[rules.required]"
                density="compact">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Last Name"
                variant="outlined"
                persistent-placeholder
                v-model="newCustomer.lastName"
                :rules="[rules.required]"
                density="compact">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Email"
                variant="outlined"
                persistent-placeholder
                :readonly="!newCustomer.isNew"
                v-model="newCustomer.email"
                :rules="[rules.required]"
                density="compact">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Phone Number"
                variant="outlined"
                persistent-placeholder
                v-model="newCustomer.phoneNumber"
                density="compact">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Username"
                variant="outlined"
                persistent-placeholder
                v-model="newCustomer.username"
                density="compact"
                :readonly="!newCustomer.isNew">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Member Id"
                variant="outlined"
                persistent-placeholder
                :readonly="!newCustomer.isNew"
                v-model="newCustomer.memberId"
                density="compact">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Notes"
                variant="outlined"
                persistent-placeholder
                v-model="newCustomer.customerNotes"
                density="compact">
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="onClose">Cancel</v-btn>
        <v-btn
          class="text-white"
          width="100"
          color="#E2215A"
          variant="flat"
          @click="onSubmitNewCustomer"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped></style>
